import jwt_decode from 'jwt-decode';

/**
 * Abgelaufen oder nicht dekodierbar? Bewusst ohne sub-Prüfung,
 * gilt damit auch für Geräte-Tokens (sub = UUID).
 *
 * @param {string|null} jwt
 * @returns {boolean}
 */
export function isJwtExpired(jwt) {
  try {
    const decoded = jwt_decode(jwt);
    return Date.now() >= decoded.exp * 1000;
  } catch (e) {
    return true;
  }
}

/**
 * Gültigkeitsprüfung des Login-Tokens (Ablauf + Benutzer-Sub).
 * Überall verwenden, wo "angemeldet?" entschieden wird,
 * sonst drohen Redirect-Schleifen (#13671).
 *
 * @param {string|null} jwt
 * @returns {boolean}
 */
export default function isJwtValid(jwt) {
  if (!jwt) {
    return false;
  }

  try {
    const decoded = jwt_decode(jwt);
    return Date.now() < decoded.exp * 1000 && Number.isInteger(decoded.sub);
  } catch (e) {
    return false;
  }
}
